// utils for solidity
export const LIGHT_CLIENT_ADDRESS =
  "0x42F9761d97cf0942a2a4966145006E172EcE3dA9";
